import WsService from "../WsService";
import UtilityLimitIncreaseProofOfAddressType from "../../domain/Limit/UtilityLimitIncreaseProofOfAddressType";
import UtilityLimitIncreaseProofOfIncomeType from "../../domain/Limit/UtilityLimitIncreaseProofOfIncomeType";
import UtilityLimitIncreaseSourceOfIncomeType from "../../domain/Limit/UtilityLimitIncreaseSourceOfIncomeType";

const ENDPOINT_BASE = "/utility/limit-increase";

export default class UtilityLimitIncreaseTypeService {

    static retrieveProofOfAddressTypes() {
        let endpoint = ENDPOINT_BASE + "/proof-of-address-type";
        return WsService.get(endpoint, {}, 200).then(
            response => {
                let results = [];
                response.forEach(singleItem => {
                    results.push(new UtilityLimitIncreaseProofOfAddressType(singleItem))
                });
                return results;
            },
            response => {
                return response;
            }
        )
    }

    static retrieveProofOfIncomeTypes() {
        let endpoint = ENDPOINT_BASE + "/proof-of-income-type";
        return WsService.get(endpoint, {}, 200).then(
            response => {
                let results = [];
                response.forEach(singleItem => {
                    results.push(new UtilityLimitIncreaseProofOfIncomeType(singleItem))
                });
                return results;
            },
            response => {
                return response;
            }
        )
    }

    static retrieveSourceOfIncomeTypes() {
        let endpoint = ENDPOINT_BASE + "/source-of-income-type";
        return WsService.get(endpoint, {}, 200).then(
            response => {
                let results = [];
                response.forEach(singleItem => {
                    results.push(new UtilityLimitIncreaseSourceOfIncomeType(singleItem))
                });
                return results;
            },
            response => {
                return response;
            }
        )
    }
}
